import { TabItem, TabList, Tabs } from "../../../../core/Tabs.js";
import type { BoxTab, BoxTabsContent } from "../../boxesContent.js";

/** All, New, Favorites: a named tab list over the grid. */
export function BoxesTabs({ value, label, options, onValueChange }: BoxTabsContent) {
  return (
    <Tabs value={value} onValueChange={(next) => onValueChange(next as BoxTab)}>
      <TabList aria-label={label}>
        {options.map((option) => (
          <TabItem key={option.value} value={option.value}>
            {option.label}
          </TabItem>
        ))}
      </TabList>
    </Tabs>
  );
}
